import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';
import { ITipsterRoute } from '../../Redirects/DynamicRoutes';

interface TipsterRoutesContext {
  tipsterRoutes: ITipsterRoute[];
  getAdjustID: (id: string) => string | undefined;
}

export const TipsterRoutesContext = createContext<TipsterRoutesContext>({
  tipsterRoutes: [],
  getAdjustID: () => undefined,
});

interface TipsterRoutesProviderProps {
  tipsterRoutes: ITipsterRoute[];
}

export const TipsterRoutesProvider: React.FC<
  TipsterRoutesProviderProps & PropsWithChildren
> = ({ tipsterRoutes, children }) => {
  const getAdjustID = (id: string) =>
    tipsterRoutes.find((route) => route.tipster_id === id)?.tracker_code;
  return (
    <TipsterRoutesContext.Provider value={{ tipsterRoutes, getAdjustID }}>
      {children}
    </TipsterRoutesContext.Provider>
  );
};

export const useTipsterRoutesContext = () => useContext(TipsterRoutesContext);
